module.exports = __webpack_public_path__ + "static/07-2a2361ade41d1f76734847b7ee380448.jpg";